<template>
  <v-app>
    <v-app-bar app color="white" flat id="appBar">
      <v-img src="@/assets/img.png" max-width="150px" contain></v-img>
      <span class="ml-4" style="font-size: 24px; font-weight: 1000">{{
        $t("title")
      }}</span>
      <v-spacer></v-spacer>
      <div class="app-bar-user-info pa-0" v-if="account">
        <v-list-item>
          <v-list-item-content>
            <v-list-item-title>{{ account.name }}</v-list-item-title>
          </v-list-item-content>

          <v-list-item-action>
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on" @click="logout">
                  <v-icon>fas fa-sign-out-alt</v-icon>
                </v-btn>
              </template>
              <span>{{ $t("logout") }}</span>
            </v-tooltip>
          </v-list-item-action>
        </v-list-item>
      </div>
    </v-app-bar>

    <v-main>
      <v-container fluid class="content-wrapper">
        <AppDrawer v-model="drawerShown"></AppDrawer>
        <router-view></router-view>
      </v-container>
    </v-main>

    <v-snackbar
      v-model="snackBarShown"
      :timeout="3000"
      :color="snackbarColor"
      top
    >
      <span v-if="!!snackbarIcon" :class="snackbarIcon"> </span>
      <!-- {{ snackBarContent }} -->
      <div v-html="snackBarContent"></div>
    </v-snackbar>

    <v-overlay :value="isLoading" z-index="9999">
      <BounceLoader color="#ff9800"></BounceLoader>
    </v-overlay>

    <LoginModal :shown="loginDialogShown"></LoginModal>
  </v-app>
</template>

<script>
import { computed, onMounted, ref, watch } from "@vue/composition-api";
import { ACTION_TYPES } from "./store/types";
import AppDrawer from "./components/AppDrawer";
import LoginModal from "./components/LoginModal";
import BounceLoader from "vue-spinner/src/BounceLoader";

export default {
  name: "App",
  components: { LoginModal, AppDrawer, BounceLoader },
  setup(props, { root }) {
    // Snack Bar
    const snackBarShown = ref(false);
    const snackBarContent = ref(root.$store.getters.snackBarContent || "");
    const snackbarColor = ref(root.$store.getters.snackBarColor || "");
    const snackbarIcon = ref(root.$store.getters.snackBarIcon || "");

    watch(
      () => root.$store.getters.snackBarContent,
      (content) => {
        if (content) {
          snackBarShown.value = true;
          snackBarContent.value = content;
          snackbarColor.value = root.$store.getters.snackBarColor;
          snackbarIcon.value = root.$store.getters.snackBarIcon;
          // alert(content);
          root.$store.dispatch(ACTION_TYPES.HIDE_SNACKBAR);
        }
      },
      { immediate: true }
    );

    watch(
      () => snackBarShown.value,
      (shown, oldShown) => {
        if (oldShown && !shown) {
          root.$store.dispatch(ACTION_TYPES.HIDE_SNACKBAR);
        }
      },
      { immediate: true }
    );

    // Loading Spinner
    const isLoading = computed(() => {
      return root.$store.getters.requestCount !== 0;
    });

    // Login
    const loginDialogShown = ref(false);
    const account = computed(() => {
      return root.$store.getters.account;
    });
    watch(
      () => account.value,
      (newValue, oldValue) => {
        if (oldValue && !newValue) {
          loginDialogShown.value = true;
          root.$router.replace({ name: "landing" });
        }

        if (newValue && !oldValue) {
          loginDialogShown.value = false;
          // root.$router.replace({name: 'landing'})
        }
      }
    );
    const logout = function () {
      if (confirm("Logout?")) {
        root.$store.dispatch(ACTION_TYPES.LOGOUT);
      }
    };

    onMounted(async () => {
      root.$store.dispatch(ACTION_TYPES.CLEAR_LOADING);

      // Check if id_token is present
      const urlParams = new URLSearchParams(window.location.search);
      const id_token = urlParams.get("id_token");

      if (id_token) {
        await root.$store.dispatch(ACTION_TYPES.CALL_API, {
          url: "teamnote_oauth/jwt/",
          params: {
            jwt: id_token,
          },
        });

        history.replaceState(
          null,
          "",
          window.location.pathname + window.location.hash
        );
      }

      try {
        await root.$store.dispatch(ACTION_TYPES.GET_ME);
      } catch (e) {
        loginDialogShown.value = true;
      }
    });

    return {
      drawerShown: ref(true),

      snackbarIcon,
      snackBarShown,
      snackBarContent,
      snackbarColor,

      loginDialogShown,
      account,
      logout,

      isLoading,
    };
  },
};
</script>

<style lang="less">
.v-application--wrap {
  height: 100vh !important;
}

.v-main {
  height: 100% !important;
  overflow: auto;
}

@media print {
  #appDrawer {
    display: none !important;
  }
  .v-main {
    height: auto !important;
    overflow: visible !important;
  }
  .v-btn {
    display: none;
  }
  .v-input--checkbox {
    display: none;
  }
}

#appBar {
  .app-bar-label {
    color: var(--v-secondary-base);
    font-weight: bold;
    min-width: 200px;
  }

  .v-toolbar__content {
    border-bottom: solid 1px #f2f2f2;
  }

  .app-bar-user-info {
    //width: 275px;
    text-align: right;

    .v-list-item__title {
      //color: var(--v-secondary-base);
    }
  }
}

.v-btn {
  &.secondary {
    .v-btn__content {
      color: black;
    }
  }
}

.v-data-table-header {
  th {
    background-color: #f4f5f7;
  }
}

.content-wrapper {
  padding-left: 68px;
  background-color: #efeeee;
  height: 100%;
}
</style>
